import { XCircle, Grid3X3 } from 'lucide-react';
import { Box, Button, HStack, Image, Portal, Skeleton, Text, useDisclosure, useOutsideClick } from '@chakra-ui/react';

import { DesignPagingProps } from './design-paging.type';
import { Designs } from './designs.type';
import { lang } from '@lang';
import { RtaIconButton } from '@components';
import { useRef } from 'react';

type DesignViewSelectionProps = DesignPagingProps & {
	designs: Designs,
	selected?: string | null,
	disabled?: boolean,
	onSelect: (id: string, version: number | null, baseVersion: number | null) => void
};

export const DesignViewSelection = (props: DesignViewSelectionProps) => {
	const { isOpen, onToggle } = useDisclosure();
	const ref = useRef(null);

	const { designs, disabled, selected = null, remaining = 0, isLoadingMore = false, onSelect, onLoadMore } = props;

	useOutsideClick({
		ref,
		handler: () => { if (isOpen) onToggle(); }
	});

	return 	<>
		<RtaIconButton icon={<Grid3X3/>} enabled={!disabled} label="View Designs" onClick={onToggle}/>
		<Portal>
			<Box
				ref={ref}
				zIndex={1000}
				position="absolute"
				display={isOpen ? 'block' : 'none'}
				bottom={'40px'}
				left={'0'}
				w="calc(100% - 0px)"
				p="10px 25px"
				bg="gray.100"
				shadow="md"
				// onClick={onToggle}
			>
				<Box position="absolute" right="10px" top="10px" onClick={onToggle}><XCircle size={'1.5em'}/></Box>

				<HStack gap="25px" overflowX="auto">
					{designs.map((design, i) => <Box key={i}>
						<Box bg="white" border="2px" height="100px" minWidth="100px" overflow={'hidden'}
							borderColor={selected === design.id ? 'blue.500' : 'gray.200'}
							onClick={() => {
								onSelect(design.id, design.version, design.baseVersion);
								onToggle();
							}}>
							<Image
								width="100%"
								height="100%"
								// margin="auto"
								// boxSize="100px"
								objectFit="cover"
								objectPosition="center"
								src={design.thumbnail}
								fallback={<Skeleton/>}
							/>
						</Box>
						<Text textAlign={'center'}>{(design.description ?? '') === '' ? 'no description' : design.description} { design.isDirty ? '*' : '' }</Text>
					</Box>)}
					{remaining > 0 && <Box minWidth="100px" alignSelf="flex-start">
						<Button
							height="100px"
							width="100px"
							whiteSpace="normal"
							fontSize="sm"
							isLoading={isLoadingMore}
							title={lang.customer.tooltip.loadMoreDesigns}
							onClick={() => onLoadMore?.()}>
							{`${lang.customer.label.loadMoreDesigns} (${remaining})`}
						</Button>
					</Box>}
				</HStack>
			</Box>
		</Portal>
	</>;
};
